
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div class="col-lg-8 col-md-12 col-xs-12">
        <p style='color: #919191;'>Service Provider Endpoints</p>
            <div class="customHr" style="width:150px">.</div>
            <p>Entity ID: <a href="{{data.entityId}}">{{ data.entityId }}</a></p>
            <p>Metadata URL: <a href="{{data.metadataUrl}}">{{ data.metadataUrl }}</a></p>
            <p style="margin-bottom:20px;">ACS URL: <a href="{{data.acsUrl}}">{{ data.acsUrl }}</a></p>

        <p style='color: #919191;'>Test IdP</p>
            <div class="customHr" style="width:150px">.</div>
            <p style="margin-bottom:10px;">Login URL: <a href="{{data.loginUrl}}">{{ data.loginUrl }}</a></p>

            <small>Note: Use incognito page to test, so that it doesn't use open user session.</small>

        <div style="margin-top:25px;">
            <a style="cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
  